<template>
  <v-select
    ref="select"
    class="custom-select"
    :items="items"
    :dense="dense"
    :multiple="multiple"
    :hide-selected="false"
    :color="'#25325F'"
    :menu-props="{minWidth:minWidth,offsetY:offsetY,attach: select, zIndex: 100}"
    :outlined="outline"
    :label="label"
    :hide-details="hideDetails"
    v-model="selectedValue"
    @update:modelValue="$emit('update:model',modelValue)"
  >
  </v-select>
</template>

<script>

export default {
  name: 'CustomSelect',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    dense: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    minWidth: {
      type: String,
      default: '100%'
    },
    outline: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    offsetY: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    modelValue: {
      type: Object,
    }
  },
  emits: ['update:model'],
  computed: {
    selectedValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:model', value);
      }
    },
  },
  data() {
    const select = null;
    const selectModel = '';
    return {
      selectModel,
      select,
    };
  },
  mounted() {
    this.select = this.$el;
  }
};
</script>

<style scoped lang="scss">
.custom-select{
  .v-list .v-list-item--active {
    color: red;
  }
}
</style>
